//Test server
// export const BASE_URL = "http://103.102.234.198:5001";
//  

//local server
// export const BASE_URL = "http://localhost:5000";


// export const BASE_URL = "http://192.168.1.10:5000";
//

//local server
// export const BASE_URL = "http://localhost:5000";

//production server
export const BASE_URL = "https://vetrivikascapital.in";

// console.log("API URL:", process.env.REACT_APP_BASE_URL)

// export const BASE_URL = process.env.REACT_APP_BASE_URL;